import React from 'react';
import './UserProfile.styl';
import User from 'records/User';
import EditUserInfoForm from 'components/pure/admin/profile/components/EditUserInfoForm';
import EditIntegrationsForm from 'components/pure/admin/profile/components/EditIntegrationsForm';
import EditRecordingSettingsForm from 'components/pure/admin/profile/components/EditRecordingSettingsForm';
import GumUserInfoBox from 'components/pure/admin/profile/components/GumUserInfoBox';

interface UserProfileProps {
  user: User;
  onEditUser: (u: User) => void;
  onEditAvatar: (a: any) => void;
  onResetPassword: (u: User) => void;
}

const UserProfile: React.FC<UserProfileProps> = ({
  user,
  onEditUser,
  onEditAvatar,
  onResetPassword,
}) => {
  const profileEditForm = !!user.globalUserId ? (
    <GumUserInfoBox user={user} userZoneFunction={tz => onEditUser(user.set('timezone', tz))} />
  ) : (
    <EditUserInfoForm
      user={user}
      onEditAvatar={onEditAvatar}
      onEditUser={onEditUser}
      onResetPassword={onResetPassword}
    />
  );
  return (
    <div className="profile">
      <div className="basic-info left">
        <h2>Personal Info</h2>
        {profileEditForm}
      </div>
      <div className="right">
        <EditRecordingSettingsForm user={user} onEditUser={onEditUser} />
        <EditIntegrationsForm user={user} />
      </div>
    </div>
  );
};

export default UserProfile;
